// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"7dbb70bc","340":"7dbb70bc","505":"7dbb70bc","766":"7dbb70bc","849":"7dbb70bc","893":"7dbb70bc","965":"7dbb70bc"}[chunkId] + ".chunk.css";
};